import React, { ReactNode } from 'react';
import Flags from 'react-phone-number-input/flags';
import { components } from 'react-select';

import { CountryWrapper, NoFlag, flagStyle } from './text-field-menu-country-components.styles';
import { Span } from '../../common.styles';

const { SingleValue } = components;

interface CountryWithFlagProps {
    flag: string;
    country: string;
    children: ReactNode;
}

export const CountryWithFlag = ({ flag, country, children }:CountryWithFlagProps) => {
    const { [flag]: FlagComponent = NoFlag } = Flags;

    return (
        <CountryWrapper>
            <FlagComponent title={country} style={flagStyle} />
            {children}
        </CountryWrapper>

    );
};

interface CountryOptionProps {
    innerProps: any;
    data: {
        label: string;
        flag: string;
    };
}

export const CountryOption = (props:CountryOptionProps) => {
    const { data, innerProps } = props;
    const { label, flag } = data;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onMouseMove, onMouseOver, ...newInnerProps } = innerProps;

    return (
        <div {...newInnerProps}>
            <CountryWithFlag country={label} flag={flag}>
                <Span>{label}</Span>
            </CountryWithFlag>
        </div>
    );
};

interface CountySingleValueProps{
    innerProps: any;
    data: {
        label: string;
        flag: string;
    };
}

export const CountySingleValue = (props:CountySingleValueProps) => {
    const { data } = props;
    const { label, flag } = data;

    return (
        <SingleValue {...props}>
            <CountryWithFlag country={label} flag={flag}>
                <Span>{label}</Span>
            </CountryWithFlag>
        </SingleValue>
    );
};
